import React from "react";
import { isNil } from "ramda";
import { styled } from "styled-components";

import { StatusView } from "affinityUI/features/statusView";

const ErrorMessage = styled.code`
  color: ${(props) => props.theme.colours.grey[400]};
  display: block;
  margin-top: 1rem;
`;

export const ErrorView: React.FC<
  React.PropsWithChildren<{ heading?: string; error?: Error; actions?: React.ReactNode; imgSrc?: string }>
> = ({ heading, error, actions, imgSrc, children }) => {
  return (
    <StatusView imgSrc={imgSrc} heading={heading} actions={actions}>
      {children}
      {!isNil(error?.message) && (
        <ErrorMessage>
          <strong>Error message: </strong>
          {error?.message}
        </ErrorMessage>
      )}
    </StatusView>
  );
};
